
import { Globe, Lock, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import PositPlusLogo from "@/components/shared/PositPlusLogo";

type PositPrivacy = 'public' | 'private' | 'exclusive';

interface PositPrivacyDropdownProps {
  privacy: PositPrivacy;
  onUpdatePrivacy: (privacy: PositPrivacy) => void;
  isPremium?: boolean;
}

const getPrivacyIcon = (privacy: PositPrivacy) => {
  switch (privacy) {
    case 'public':
      return <Globe className="h-4 w-4" />;
    case 'exclusive':
      return <Share2 className="h-4 w-4" />;
    default:
      return <Lock className="h-4 w-4" />;
  }
};

const PositPrivacyDropdown = ({ privacy, onUpdatePrivacy, isPremium = false }: PositPrivacyDropdownProps) => {
  const handlePrivacyChange = (newPrivacy: PositPrivacy) => {
    if (!isPremium && (newPrivacy === 'private' || newPrivacy === 'exclusive')) {
      return;
    }
    onUpdatePrivacy(newPrivacy);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="h-10 gap-2">
          {getPrivacyIcon(privacy)}
          <span className="capitalize">{privacy}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem 
          className="gap-2"
          onClick={() => handlePrivacyChange('public')}
        >
          <Globe className="h-4 w-4" />
          <span>Public</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          className={`gap-2 ${!isPremium ? 'opacity-50 cursor-not-allowed' : ''}`}
          onClick={() => handlePrivacyChange('exclusive')}
        >
          <Share2 className="h-4 w-4" />
          <span>Exclusive</span>
          {!isPremium && <PositPlusLogo size="sm" className="ml-auto" />}
        </DropdownMenuItem>
        <DropdownMenuItem 
          className={`gap-2 ${!isPremium ? 'opacity-50 cursor-not-allowed' : ''}`}
          onClick={() => handlePrivacyChange('private')}
        >
          <Lock className="h-4 w-4" />
          <span>Private</span>
          {!isPremium && <PositPlusLogo size="sm" className="ml-auto" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PositPrivacyDropdown;

